<template>
  <div class="dashboard" style="max-width: 100%; padding-left: 2em; padding-right: 2em; padding-top: 4em; padding-bottom: 1em;" id="files">
    <ul id="nav">
      <li :class="{ active: $route.path === '/shared-drive/my-drives'}"><router-link to="/shared-drive/my-drives">{{ $t('sidebar.myUnits') }}</router-link></li>
      <li :class="{ active: $route.path === '/shared-drive/shared-with-me'}"><router-link to="/shared-drive/shared-with-me">{{ $t('sidebar.sharedWithMe') }}</router-link></li>
      <li :class="{ active: $route.path === '/shared-drive/archived'}"><router-link to="/shared-drive/archived">{{ $t('sidebar.archived') }}</router-link></li>
    </ul>

    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex';

export default {
  name: 'shared-drive',
  computed: {
    ...mapGetters([
      'selectedCount',
      'isListing',
      'isEditor',
      'isFiles'
    ]),
    ...mapState([
      'req',
      'user',
      'reload',
      'multiple',
      'loading',
      'isDelete'
    ]),
    isPreview () {
      return false;
    }
  },
  data: function () {
    return {
      error: null
    };
  },
  created () {
    this.$store.commit('updateRequest', {});
  },
  watch: {
    'reload': function () {
    }
  },
  mounted () {
    window.addEventListener('keydown', this.keyEvent);
    window.addEventListener('scroll', this.scroll);
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.keyEvent);
    window.removeEventListener('scroll', this.scroll);
  },
  destroyed () {
    this.$store.commit('updateRequest', {});
  },
  methods: {
    ...mapMutations([ 'setLoading' ]),
    keyEvent (event) {
      // Esc!
      if (event.keyCode === 27) {
        this.$store.commit('closeHovers');

        // If we're on a listing, unselect all
        // files and folders.
        if (this.isListing) {
          this.$store.commit('resetSelected');
        }
      }

      // Del!
      if (event.keyCode === 46) {
        if (!this.isFiles ||
          this.loading ||
          (this.isListing && this.selectedCount === 0) || this.isDelete) return;

        this.$store.commit('showHover', 'delete');
      }

      // F1!
      if (event.keyCode === 112) {
        event.preventDefault();
        this.$store.commit('showHover', 'help');
      }
    },
    scroll () {
      if (this.req.kind !== 'listing' || this.$store.state.user.viewMode === 'mosaic') return;

      let top = 112 - window.scrollY;

      if (top < 64) {
        top = 64;
      }

      document.querySelector('#listing.list .item.header').style.top = top + 'px';
    },
    openSidebar () {
      this.$store.commit('showHover', 'sidebar');
    },
    openSearch () {
      this.$store.commit('showHover', 'search');
    }
  }
};
</script>
